/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

export const useDeviceType = () => {
  const androidDevice = Boolean(navigator.userAgent.match(/Android/i));
  const iPhoneDevice = Boolean(navigator.userAgent.match(/iPhone/i));

  const iPadDevice = Boolean(
    navigator.userAgent.match(/iPad/i) ||
      (navigator.maxTouchPoints &&
        navigator.maxTouchPoints > 2 &&
        /MacIntel/.test(navigator.platform)),
  );

  const isMobilePhoneDevice = iPhoneDevice || androidDevice;

  return {
    androidDevice,
    iPhoneDevice,
    iPadDevice,
    isMobilePhoneDevice,
  };
};
